module.exports = __webpack_public_path__ + "img/icon-bell.125551e9.svg";